import React from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
///@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Row,
    Panel,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import CustomFormForm, { CustomForm } from "../../forms/CustomFormForm";
export const CustomFormCreate = ({ path }) => {
    const history = useHistory();

    const item: CustomForm = {
        name: "",
        alias: "",
        type: "",
        // description: "",
        // thumbnail: "",
        // order: 0,
        locale: "",
        custom_form_fields: [],
    };

    const submitForm = (values) => {
        return axios
            .post(`/api/v1/admin/custom-form`, values)
            .then(({ data }) => {
                //As creation was successful move them on to the appropriate listing page
                history.push(`${path}/edit/${data.data.uuid}`);
                // //As creation was successful move them on to the appropriate listing page
                // history.push(`${path}`);

                return data.data;
            });
    };
    return (
        <div>
            <PageTitle
                title={
                    <React.Fragment>
                        {trans("New Custom Form")}{" "}
                        {/* <HeaderEmphasis>{assetAdmin.asset.name}</HeaderEmphasis> */}
                    </React.Fragment>
                }
            >
                <IconTextButton
                    as={Link}
                    to={path}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>

            <Row>
                <Panel>
                    <CustomFormForm item={item} submitForm={submitForm} />
                </Panel>
            </Row>
        </div>
    );
};

export default CustomFormCreate;
